export default "__VITE_ASSET__BhaxcXH8__"